import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { restServices } from 'src/app/rest.service';
import { ModelloCambioObiettivoInputDTO } from '../../models/entities/modello-cambio-obiettivo-input-dto';
import { ModelloCambioObiettivoOutputDTO } from '../../models/entities/modello-cambio-obiettivo-output-dto';

@Injectable()
export class CambioObiettivoService {

  resourceUrl = environment.api_rischiocambio_url + restServices.cambioObiettivo;

  constructor(private http: HttpClient) { }

  calcolaModello(input: ModelloCambioObiettivoInputDTO): Observable<HttpResponse<ModelloCambioObiettivoOutputDTO[]>> {
    return this.http.post<ModelloCambioObiettivoOutputDTO[]>(`${this.resourceUrl}/calcola-modello`, input, { observe: 'response' });
  }

}